import React from 'react';
import { Table, Column, Cell } from 'fixed-data-table';
import { Button } from 'react-bootstrap';
import { sortBy } from 'lodash';

import { SortHeaderCell, DataListWrapper, getDefaultTableDataObj } from '../../../commonComponents/DataTable/DataTablePs';
import treeViewGenerator from '../../../commonComponents/treeViewGenerator';
import CategoryModalCt from './CategoryModalCt';
import SpecModalCt from './SpecModalCt';
import custJqAjax from '../../../commonJS/custJqAjax';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import searchContent from '../../../commonJS/searchContent';



const SpecCell = ({ rowIndex, sortedData, columnKey, onClick, onSpecClick, ...props }) => (
  <Cell {...props} onClick={e => { if (onClick) onClick(e, rowIndex, sortedData); }}>
    {sortedData.getObjectAt(rowIndex)[columnKey]}
    {/* <Button
      style={{
        float: 'right',
        height: 26,
        padding: "1px 3px",
        marginRight: 8,
        marginTop: -3
      }}
      onClick={e => { if (onSpecClick) onSpecClick(e, rowIndex, sortedData); }}>
      規格
    </Button> */}
  </Cell>
);

export default class ProductCt extends React.Component {
  constructor(props) {
    super(props);

    this.handlers = {
      onRowClick: (e, rowIndex, sortedData, keepRoute) => {
        const selectedProduct = sortedData.getObjectAt(rowIndex);
        if (!keepRoute) this.props.routeHandler(`/salesky/product/${selectedProduct.id}`);
        this.setState({
          selectedRowIndex: rowIndex,
          selectedProductId: selectedProduct.id,
          selectedProductName: selectedProduct.name
        });
      },
      onSpecClick: (e, rowIndex, sortedData) => {
        e.stopPropagation();
        const selectedProduct = sortedData.getObjectAt(rowIndex),
          id = selectedProduct.id,
          name = selectedProduct.name; // 多國

        this.setState({
          showSpecModal: true,
          selectedRowIndex: rowIndex,
          selectedProductId: id,
          selectedProductName: name
        });
      },
      onSortChange: (columnKey, sortDir, SortTypes, indexes, data) => {
        // 前3個參數預設由子元件傳入，後兩個視使用當下情況自行傳入
        let sortIndexes = indexes || this.props.propsFromSaleSky.productProps.productSortedData._indexMap;
        const orinData = data || this.props.propsFromSaleSky.productProps.productSortedData._data;

        sortIndexes.sort((indexA, indexB) => {

          const valueA = orinData[indexA][columnKey];
          const valueB = orinData[indexB][columnKey];
          let sortVal = 0;
          if (valueA > valueB) {
            sortVal = 1;
          }
          if (valueA < valueB) {
            sortVal = -1;
          }
          if (sortVal !== 0 && sortDir === SortTypes.ASC) {
            sortVal *= -1;
          }

          return sortVal;
        });

        this.props.stateHandler({
          states: ['productSortedData', 'productColSortDirs'],
          newValues: [new DataListWrapper(sortIndexes, orinData),
          {
            [columnKey]: sortDir
          }]
        });
      }
    };

    this.treeViewFuncs = {
      onTreeViewNodeClick: (parentObj, selectedTracks, selectedTrackNames, selectedTrackIds) => {
        const productProps = this.props.propsFromSaleSky.productProps,
          lastPos = selectedTracks.length - 1,
          ind = selectedTracks[lastPos];

        let collapses = this.state.collapsesState,
          productCategories = productProps.productCategories,
          collapseKey = selectedTrackIds[lastPos];

        collapses[collapseKey] = !collapses[collapseKey];

        const { productTreeView, collapsesState } = treeViewGenerator(productCategories, collapses, this.treeViewFuncs.onTreeViewNodeClick, selectedTrackIds[lastPos], this.state.showTreeEdit, this.treeViewFuncs.onModifyBtnsClick, 'name_tw');

        // 更新顯示路徑
        const len = selectedTrackNames.length;
        let categoryPath = "";
        for (let i = 0; i < len; i++) {
          categoryPath += selectedTrackNames[i] + ' / ';
        }

        this.props.stateHandler({
          states: ['productTreeView'],
          newValues: [productTreeView]
        });

        // 是否抓取新資料
        // const tarObj = this.treeViewFuncs.locator(productCategories, selectedTracks),
        const tarObj = (lastPos === 0 ? parentObj : parentObj.product_category_ids_sorts[ind]),
          childCategories = tarObj.product_category_ids_sorts;

        if (childCategories.length && !childCategories[0].product_category_ids_sorts) {
          let len = childCategories.length;
          for (let i = 0; i < len; i++) {
            this.treeViewFuncs.loadCategoryData(childCategories, i);
          }
        }

        this.treeViewFuncs.updateProductTable(tarObj);
        // 離開即重置的狀態由this管理
        this.setState({ doSearchUpdate: 1, collapsesState, activeCateObj: tarObj, selectedTracks, categoryPath, selectedTrackIds });

      },
      updateProductTable: tarObj => {
        // 更新product table資料
        const productProps = this.props.propsFromSaleSky.productProps;
        let filteredData = [];

        if (tarObj.id === '0') {
          filteredData = productProps.productOrinData;
        } else {
          // 轉文字
          const idTextList = tarObj.product_ids_sorts.map((item, ind) => item.id);

          filteredData = searchContent(idTextList, productProps.productOrinData, ['id'], '', 1);
        }

        const productSortedData = getDefaultTableDataObj(filteredData);

        // 更新資料時依排序設定更新排序
        if (Object.keys(productProps.productColSortDirs).length) {
          this.handlers.onSortChange('name', productProps.productColSortDirs.name, { ASC: 'ASC', DESC: 'DESC' }, productSortedData._indexMap, productSortedData._data);
        }

        this.props.stateHandler({
          states: 'productSortedData',
          newValues: productSortedData
        });

      },
      locator: arrTracks => {
        const len = arrTracks.length;

        // 定位目標物件
        if (len) {
          let tempA = this.props.propsFromSaleSky.productProps.productCategories,
            tempB = {};


          for (let i = 1; i < len; i++) {
            tempB = tempA;
            tempA = tempB['product_category_ids_sorts'][arrTracks[i]];
          }

          return tempA;
        }

      },
      dataTranslator: resData => {
        let nodeObj = {};

        // 轉譯為標準格式
        nodeObj.id = resData.id;
        nodeObj.name_tw = resData.name_tw;
        nodeObj.name_en = resData.name_en;
        nodeObj.name_cn = resData.name_cn;
        nodeObj.name_ja = resData.name_ja;
        nodeObj.product_category_ids_sorts = resData.product_category_ids_sorts;
        nodeObj.product_ids_sorts = resData.product_ids_sorts;
        nodeObj.sort = resData.sort ? parseInt(resData.sort, 10) : "";

        return nodeObj;
      },
      loadCategoryData: (childCategories, sort) => {
        const id = childCategories ? childCategories[sort].id : 0;
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_ProductCategories_Lang_Get.php?id=${id}`,
          success: res => {
            let productCategories = this.props.propsFromSaleSky.productProps.productCategories,
              nodeObj = this.treeViewFuncs.dataTranslator(res.result);
            // childCategories = [];

            // childCategories是productCategoreis裡面的一個key參照到的arr
            // 所以改變此arr，連帶也會改變productCategories的內容

            // 分類預排序 ======
            const len = nodeObj.product_category_ids_sorts.length;
            // 轉數字
            for (let i = 0; i < len; i++) {
              nodeObj.product_category_ids_sorts[i].sort *= 1;
            }
            // 排序
            const childCate = sortBy(nodeObj.product_category_ids_sorts, ['sort']);
            nodeObj.product_category_ids_sorts = childCate;
            // ===============

            if (!productCategories.id) {
              productCategories = nodeObj;
            } else {
              // childCategories = this.treeViewFuncs.locator(productCategories, this.state.selectedTracks).product_category_ids_sorts;
              childCategories.splice(sort, 1, nodeObj);
            }

            const { productTreeView, collapsesState } = treeViewGenerator(productCategories, this.state.collapsesState, this.treeViewFuncs.onTreeViewNodeClick, this.state.activeCateObj.id || '0', this.state.showTreeEdit, this.treeViewFuncs.onModifyBtnsClick, 'name_tw');

            this.setState({ collapsesState });

            this.props.stateHandler({
              states: ['productCategories', 'productTreeView'],
              newValues: [productCategories, productTreeView]
            });
          }
        });
      },
      onTreeEditClick: () => {

        const showTreeEdit = !this.state.showTreeEdit,
          activeCateId = (this.state.selectedTrackIds[this.state.selectedTrackIds.length - 1] || '0'),
          { productTreeView, collapsesState } = treeViewGenerator(this.props.propsFromSaleSky.productProps.productCategories, this.state.collapsesState, this.treeViewFuncs.onTreeViewNodeClick, activeCateId, showTreeEdit, this.treeViewFuncs.onModifyBtnsClick, 'name_tw');

        this.setState({ collapsesState, showTreeEdit });

        this.props.stateHandler({
          states: 'productTreeView',
          newValues: productTreeView
        });
      },
      genPathIdList: (trackIds, includeSelf) => {
        let len = trackIds.length,
          pathIdList = '0';

        if (!includeSelf) len--;

        for (let i = 1; i < len; i++) {
          pathIdList += `,${trackIds[i]}`;
        }
        return pathIdList;
      },
      onModifyBtnsClick: (mode, trackIds, parentObj, ind) => {
        if (mode === 'delete') {
          const id = trackIds[trackIds.length - 1],
            path = this.treeViewFuncs.genPathIdList(trackIds);

          this.treeViewFuncs.deleteCategory(id, path, parentObj, ind);

        } else {
          let tarCateParentObj = parentObj,
            tempObj = {};

          tempObj.pathIdList = this.treeViewFuncs.genPathIdList(trackIds);

          switch (mode) {
            case 'create':
              // 新增時，新分類的parent是自己
              tarCateParentObj = parentObj ? parentObj.product_category_ids_sorts[ind] : "";
              tempObj.tarCateParentObjChildNum = (
                tarCateParentObj ?
                  tarCateParentObj.product_category_ids_sorts.length
                  :
                  this.props.propsFromSaleSky.productProps.productCategories.product_category_ids_sorts.length
              );

              tempObj.pathIdList = this.treeViewFuncs.genPathIdList(trackIds, 1);
              break;
            case 'edit':
            case 'copy':
              tempObj.tarCateObj = parentObj.product_category_ids_sorts[ind];
              tempObj.tarCateParentObjChildNum = tarCateParentObj.product_category_ids_sorts.length;
              break;
            default:
          }

          this.setState({ showCategoryModal: true, tarCateParentObj, categoryActionMode: mode, ...tempObj });
        }
      },
      sortUpdator: tarCateParentObj => {
        // 重編sort，假設原本排序即以sort排，需在原始資料預處理
        let childObj = "", sort_id_list = [];
        for (let i = 0; 1; i++) {
          childObj = tarCateParentObj.product_category_ids_sorts[i];
          if (childObj) {
            childObj.sort = i + 1;
            sort_id_list.push(childObj.id);
          } else {
            break;
          }
        }
        // 更新後端sort
        let sortFormData = new FormData();
        sortFormData.append('type', 'category');
        sortFormData.append('id_list', sort_id_list.join());

        custJqAjax({
          type: 'POST',
          url: '/api/W_SaleSky_ProductCategories_Relation_Sort_Update.php',
          data: sortFormData,
          processData: false,
          contentType: false,
          success: res => { }
        });
      },
      onTreeViewModified: (mode, addedCateId, addedCateName, addedCateSort) => {

        const tarCateParentObj = this.state.tarCateParentObj || this.props.propsFromSaleSky.productProps.productCategories;
        // 更新productCategories
        let newObj = {
          id: addedCateId,
          name_tw: addedCateName.name_tw,
          name_en: addedCateName.name_en,
          name_cn: addedCateName.name_cn,
          name_ja: addedCateName.name_ja,
          product_category_ids_sorts: [],
          product_ids_sorts: [],
          sort: addedCateSort
        };

        if (mode === 'update') {
          newObj.product_category_ids_sorts = this.state.tarCateObj.product_category_ids_sorts;
          newObj.product_ids_sorts = this.state.tarCateObj.product_ids_sorts;
        }

        if (!tarCateParentObj.product_category_ids_sorts[0]) {
          // 無子階
          tarCateParentObj.product_category_ids_sorts.push(newObj);
        } else if (tarCateParentObj.product_category_ids_sorts[0].product_category_ids_sorts) {
          // 有子階且已下載(複製和修改只會發生在此情況底下)
          if (mode === 'update') {
            // 修改可以想成是把舊的刪除，然後新增一個取代
            // 所以和一般新增與複製的差別只在多一個刪除的動作
            let oldInd = searchContent([addedCateId], tarCateParentObj.product_category_ids_sorts, ['id'], 1, 1);
            tarCateParentObj.product_category_ids_sorts.splice(oldInd, 1);
          }

          tarCateParentObj.product_category_ids_sorts.splice(addedCateSort - 1, 0, newObj);

        } else {
          // 有子階但尚未下載
          newObj = {
            id: addedCateId,
            sort: addedCateSort
          };

          tarCateParentObj.product_category_ids_sorts.splice(addedCateSort - 1, 0, newObj);

        }

        this.treeViewFuncs.sortUpdator(tarCateParentObj);

        // 直接改obj，需要更新
        this.props.stateHandler({ states: 'productCategories', newValues: this.props.propsFromSaleSky.productProps.productCategories });

        this.treeViewFuncs.refreshTreeView();

      },
      closeModal: (isSpec) => {

        const stateName = isSpec === 1 ? 'showSpecModal' : 'showCategoryModal';

        this.setState({ [stateName]: false });
      },
      deleteCategory: (category_id, path_id_list, parentObj, tarInd) => {
        let formData = new FormData();
        formData.append('category_id', category_id);
        formData.append('path_id_list', path_id_list);

        custJqAjax({
          type: 'POST',
          url: '/api/W_SaleSky_ProductCategories_Relation_Delete.php',
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            if (res.status === '0') {
              this.treeViewFuncs.removeItemFromTreeView(parentObj, tarInd, category_id);
            }
          }
        });
      },
      removeItemFromTreeView: (parentObj, tarInd, id) => {
        let tempObj1 = {}, tempObj2 = { states: [], newValues: [] },
          cateHomeArr = parentObj.product_category_ids_sorts,
          resetActiveCateId = false,
          collapsesState = this.state.collapsesState;

        // 從collapsesState中移除
        collapsesState[parentObj.product_category_ids_sorts[tarInd].id] = undefined;

        // 從productCategories中移除，因只是物件的一個key，物件複製較為搞剛，直接改再更新

        cateHomeArr.splice(tarInd, 1);
        tempObj2.states.push('productCategories');
        tempObj2.newValues.push(this.props.propsFromSaleSky.productProps.productCategories);
        // 刪除的為作用中分類處理

        if (this.state.activeCateObj.id === id) {
          // 移除selectedTracks, selectedTrackIds, activeCateObj, tarCateParentObj
          tempObj1.selectedTracks = [0];
          tempObj1.selectedTrackIds = [];
          tempObj1.activeCateObj = "";
          tempObj1.tarCateParentObj = "";
          resetActiveCateId = true;

          // 更新product table 資料

          tempObj2.states.push('productSortedData');
          tempObj2.newValues.push(getDefaultTableDataObj(this.props.propsFromSaleSky.productProps.productOrinData));

        }

        // 更新sort

        this.treeViewFuncs.sortUpdator(parentObj);

        this.setState({
          ...tempObj1
        });

        this.props.stateHandler(tempObj2);

        this.treeViewFuncs.refreshTreeView(resetActiveCateId);

      },
      refreshTreeView: resetActiveCateId => {
        const activeCateId = (resetActiveCateId ? '0' : this.state.selectedTrackIds[this.state.selectedTrackIds.length - 1]);

        const { productTreeView, collapsesState } = treeViewGenerator(this.props.propsFromSaleSky.productProps.productCategories, this.state.collapsesState, this.treeViewFuncs.onTreeViewNodeClick, activeCateId, this.state.showTreeEdit, this.treeViewFuncs.onModifyBtnsClick, 'name_tw');

        this.setState({ collapsesState });

        this.props.stateHandler({
          states: 'productTreeView',
          newValues: productTreeView
        });
      }
    }


    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];

    // this.timer = {};

    this.state = {
      selectedRowIndex: '',
      selectedProductId: '',
      selectedProductName: '',
      doSearchUpdate: 0,
      // tree view
      categoryPath: '',
      tarCateParentObj: "",// 儲存最近編輯的分類之parent物件，與active分類不一定相同
      tarCateObj: "",
      activeCateObj: "", // 儲存使用中分類物件
      tarCateParentObjChildNum: 0,
      pathIdList: "",
      selectedTrackIds: [],
      categoryActionMode: 'create',
      showTreeEdit: false,
      showCategoryModal: false,
      collapsesState: {}, // 以categories id做為key，管控各tacks摺疊狀態
      selectedTracks: [0], // 隨階層push array，值為sort
      // spec
      showSpecModal: false
    };
  }

  componentDidMount() {
    let productProps = this.props.propsFromSaleSky.productProps,
      jqAjaxIdGenerator = this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator;

    if (!productProps.productSortedData._data) {
      custJqAjax({
        type: 'GET',
        ajaxsWip: this.ajaxsWip,
        custId: jqAjaxIdGenerator.getId(),
        url: '/api/M_SaleSky_Product_Get.php',
        success: res => {
          let data = res.result, len = data.length, defaultSortIndexes = [],
            sortedData = [];

          for (let i = 0; i < len; i++) {
            defaultSortIndexes.push(i);
          }

          sortedData = new DataListWrapper(defaultSortIndexes, data);

          this.props.stateHandler({
            states: ['productOrinData', 'productSortedData', 'productDefaultSortIndexes'],
            newValues: [data, sortedData, defaultSortIndexes]
          });

        }
      });
    }

    if (!productProps.productCategories.id) {
      this.treeViewFuncs.loadCategoryData(0, 0);
    } else {
      this.treeViewFuncs.refreshTreeView();
    }

  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.doSearchUpdate) {
      this.setState({ doSearchUpdate: 0 });
      this.props.updateSearchResults();
    }
  }

  componentWillUnmount() {
    this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
    /* 
      因為productTreeView中儲存的是元件，並儲存在上層的salesky，其onClick func中所指向的this
      卻是ProductCt 當ProductCt unmount之後，再次mount時和productTreeView中的this已是不同instance
      這時觸發onClick就會出現setState on an unmounted component警告
      所以要在unmount之前先將productTreeView清空
    */

    const productProps = this.props.propsFromSaleSky.productProps;

    this.props.stateHandler({
      states: ['productTreeView', 'productSortedData'],
      newValues: [[], (productProps.productOrinData.length ? getDefaultTableDataObj(productProps.productOrinData) : productProps.productSortedData)]
    });

  }

  render() {
    let { productSortedData, productColSortDirs, productOrinData, productTreeView, productCategories } = this.props.propsFromSaleSky.productProps;

    // search process
    let sortFunc = this.handlers.onSortChange;
    if (this.props.searchResults._data) {
      productSortedData = this.props.searchResults;
      sortFunc = "";
    }

    const modal = (this.props.children ? React.cloneElement(this.props.children, {
      closeModal: this.props.closeModal,
      propsPackageFromSkyFamily: this.props.propsPackageFromSkyFamily,
      productSortedData,
      productOrinData,
      stateHandler: this.props.stateHandler,
      parentStateHandler: this.parentStateHandler,
      selectedRowIndex: this.state.selectedRowIndex,
      selectedProductId: this.state.selectedProductId,
      onRowClick: this.handlers.onRowClick,
      productCategories,
      categoryPath: this.state.categoryPath,
      selectedTrackIds: this.state.selectedTrackIds,
      selectedTracks: this.state.selectedTracks,
      collapsesState: this.state.collapsesState,
      activeCateObj: this.state.activeCateObj,
      updateProductTable: this.treeViewFuncs.updateProductTable,
      refreshTreeView: this.treeViewFuncs.refreshTreeView,
      showTreeEdit: this.state.showTreeEdit
    }) : ""),

      tableWidth = (this.props.tabWidth || ((this.props.isBigSideBar ? 0 : 186) + this.props.workLogProps.tableWidth)) / 2,
      tableHeight = this.props.tabHeight || (this.props.tableHeight || 477);

    return (
      <div id="div-product-content-container">

        <div id="div-product-content-left-side">
          {
            productSortedData._data ?
              <Table
                onRowClick={(e, rowIndex) => { this.handlers.onRowClick(e, rowIndex, productSortedData); }}
                rowHeight={50}
                headerHeight={50}
                rowsCount={productSortedData.getSize()}
                width={tableWidth}
                height={tableHeight}>

                <Column
                  columnKey="name"
                  header={
                    <SortHeaderCell
                      onSortChange={sortFunc}
                      sortDir={productColSortDirs.name}>
                      產品名稱
                    </SortHeaderCell>
                  }
                  cell={<SpecCell sortedData={productSortedData} onSpecClick={this.handlers.onSpecClick} />}
                  flexGrow={0}
                  width={tableWidth}
                />

              </Table>
              :
              "Data loading..."
          }


        </div>

        <div
          id="div-product-content-right-side"
          style={{
            height: tableHeight,
            borderRight: '1px solid rgb(211, 211, 211)',
            borderBottom: '1px solid rgb(211, 211, 211)',
            backgroundColor: 'white'
          }}>

          <div style={{
            height: 51,
            // width: '50%',
            lineHeight: '51px',
            fontSize: 16,
            color: 'white',
            backgroundColor: 'rgb(5, 110, 185)',
            borderTop: '1px solid rgb(211, 211, 211)',
            borderBottom: '1px solid rgb(211, 211, 211)',
            paddingLeft: 8,
            position: 'relative'
          }}>
            產品分類

            <Button
              id="btn-edit-tree"
              onClick={this.treeViewFuncs.onTreeEditClick}>
              {this.state.showTreeEdit ? '關閉' : '開啟'}編輯
            </Button>
          </div>
          <div id="div-tree-view-container" style={{ height: tableHeight - 52 }}>
            {productTreeView}
          </div>

        </div>

        {modal}
        {
          this.state.showCategoryModal ?
            <CategoryModalCt
              closeModal={this.treeViewFuncs.closeModal}
              categoryActionMode={this.state.categoryActionMode}
              tarCateParentObj={this.state.tarCateParentObj}
              tarCateObj={this.state.tarCateObj}
              tarCateParentObjChildNum={this.state.tarCateParentObjChildNum}
              pathIdList={this.state.pathIdList}
              onTreeViewModified={this.treeViewFuncs.onTreeViewModified}
              categoryPath={this.state.categoryPath} />
            :
            ""
        }

        {
          this.state.showSpecModal ?
            <SpecModalCt
              closeModal={this.treeViewFuncs.closeModal}
              parentStateHandler={this.parentStateHandler}
              allKeyPartsData={[]}
              selectedRowIndex={this.state.selectedRowIndex}
              onRowClick={this.handlers.onRowClick}
              productSortedData={productSortedData}
              productOrinData={productOrinData}
              productId={this.state.selectedProductId}
              productName={this.state.selectedProductName}
              propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily} />
            :
            ""
        }

      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/salesky/routes/product/ProductCt.jsx